import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Order, QueryConfig, QueryEntity } from '@datorama/akita';

import { PatientCurveState, PatientCurveStore } from './patient-curve.store';

@Injectable({ providedIn: 'root' })
@QueryConfig({
  sortBy: 'rank_order',
  sortByOrder: Order.ASC,
})
export class PatientCurveQuery extends QueryEntity<PatientCurveState> {
  patientCurves = toSignal(this.selectAll(), {
    requireSync: true,
  });

  protected store: PatientCurveStore;

  constructor() {
    const store = inject(PatientCurveStore);

    super(store);

    this.store = store;
  }
}
